module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"soundSettingsTitle\" class=\"prop-header\"><span class=\"prop-label\">Sound Settings</span></div>\r\n<div class=\"prop-detail main-picture\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-4 prop-sublabel\">Asset</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <select id=\"assetSelect\" name=\"asset\" >\r\n                <option value=\"\">None</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-6\">\r\n            <input type=\"checkbox\" name=\"autoPlay\" > Autoplay\r\n        </div>\r\n        <div class=\"col-md-6 nopadding\">\r\n            <input type=\"checkbox\" name=\"loop\" > Loop\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-2\" style=\"font-size: 24px;\">\r\n            <i class=\"fa pf-sound\"></i>\r\n        </div>\r\n        <div class=\"col-md-10\" style=\"height: 24px; padding-top: 9px;\">\r\n            <div id=\"volume\"></div>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}